import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartaCorrecaoModalComponent } from './carta-correcao-modal.component';
import { SharedModule } from '../../shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [CartaCorrecaoModalComponent],
  imports: [
    CommonModule, SharedModule, ReactiveFormsModule
  ]
})
export class CartaCorrecaoModalModule { }
